import { useMemo, useEffect } from 'react';
import { calcularEstatisticasCompletas } from '@/features/laudo/utils/estatisticas-nbr14653';
import { validarNumeroAmostras } from '@/features/laudo/utils/validacoes-laudo';
import type { AlertaItem } from '../AlertaGlobal/types';
import type { EstatisticasHomogeneizacao } from './types';
import { filtrarValoresValidos } from './utils';

export function useCardHomogeneizacao(
  dadosValorTerreno: Array<{ valorUnitarioFinal: number }>,
  onAlertas?: (alertas: AlertaItem[]) => void
) {
  const estatisticas = useMemo<EstatisticasHomogeneizacao>(() => {
    const valoresValidos = filtrarValoresValidos(dadosValorTerreno);
    const stats = calcularEstatisticasCompletas(valoresValidos);

    const media = stats.media;

    return {
      numeroElementos: stats.numeroElementos,
      unitarioHomog: media,
      desvioPadrao: stats.desvioPadrao,
      coeficienteVariacao: stats.coeficienteVariacao,
      tStudent: stats.tStudent,
      limiteSuperior: media * 1.3,
      limiteInferior: media * 0.7,
      intervaloConfiabilidade: stats.intervaloConfiabilidade,
    };
  }, [dadosValorTerreno]);

  const validacaoNumeroAmostras = useMemo(() => {
    return validarNumeroAmostras(estatisticas.numeroElementos);
  }, [estatisticas.numeroElementos]);

  useEffect(() => {
    if (!onAlertas) return;

    const alertas: AlertaItem[] = [];

    if (validacaoNumeroAmostras.tipo === 'erro' || validacaoNumeroAmostras.tipo === 'alerta') {
      alertas.push({
        tipo: validacaoNumeroAmostras.tipo,
        mensagem: validacaoNumeroAmostras.mensagem,
        detalhes: validacaoNumeroAmostras.detalhes,
        origem: 'homogeneizacao',
      });
    }

    onAlertas(alertas);
  }, [validacaoNumeroAmostras, onAlertas]);

  return {
    estatisticas,
  };
}
